module.exports = __webpack_public_path__ + "static/media/Logo.15d1c9be.png";